export class Encarte {
  private numero:   number;
  private nome:     string;
  private usuario: number;
  private data_ini: string;
  private data_fim: string;
  private data_inc: string;
  private hora_inc: string;
  private situacao: string;
  private ws_down:  string;
  private tipo:  string;
  private uf:  string;

  public toClass(encarte) {
    this.numero   = encarte.numero;
    this.nome     = encarte.nome;
    this.usuario  = encarte.usuario;
    this.data_ini = encarte.data_ini;
    this.data_fim = encarte.data_fim;
    this.data_inc = encarte.data_inc;
    this.hora_inc = encarte.hora_inc;
    this.situacao = encarte.situacao;
    this.ws_down  = encarte.ws_down;
    this.uf       = encarte.uf;
    this.tipo     = encarte.tipo;

  }

  public toJSON() {
    return {
      numero:   this.numero,
      nome:     this.nome,
      usuario:  this.usuario,
      data_ini: this.data_ini,
      data_fim: this.data_fim,
      data_inc: this.data_inc,
      hora_inc: this.hora_inc,
      situacao: this.situacao,
      ws_down:  this.ws_down,
      tipo:     this.tipo,
      uf:       this.uf
    }
  }
}
